export const parseYoutubeUrl = (customUrl: string) => {
  // TODO: needs updating for new implementation
  return customUrl.startsWith('http') ? customUrl : `https://${handle}`;
};

export const parseTwitchUrl = (url: string) => {
  // TODO: needs updating for new implementation
  return `https://www.twitch.tv/${url}`;
};
